module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginpage"
  }, [_c('div', {
    staticClass: "login-box",
    class: {
      changewidth: _vm.isActive
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/login/logopaybay.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-title"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('el-form', {
    ref: "pwdForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.pwdForm,
      "rules": _vm.pwdrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.pwdForm.username),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "username", $$v)
      },
      expression: "pwdForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "oldpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码"
    },
    model: {
      value: (_vm.pwdForm.oldpassword),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "oldpassword", $$v)
      },
      expression: "pwdForm.oldpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.pwdForm.newpassword),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newpassword", $$v)
      },
      expression: "pwdForm.newpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newpasswordr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.pwdForm.newpasswordr),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newpasswordr", $$v)
      },
      expression: "pwdForm.newpasswordr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-group has-feedback submitlog"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('pwdForm')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('pwdForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('router-link', {
    staticClass: "fb-touch",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("返回登录")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-661dcc53!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePwd.vue
// module id = 1073
// module chunks = 2